import { useController } from 'react-hook-form';
import DatePickerBase, {
  DatePickerBaseProps,
} from './date-picker-base/date-picker-base.component';
import { DateTime } from 'luxon';
import { IncField } from '../fields.types';

export type DatePickerFieldProps = {
  sx?: any;
  formatValue?: (val: DateTime) => any;
} & Partial<IncField<DatePickerBaseProps>>;

// Date-only picker: keep the stored wall-clock date and attach the field's
// zone instead of converting the instant. Converting breaks when luxon
// truncates second-precision historical offsets (e.g. LA = -07:52:58 while
// typing year 0002), which round-trips to 23:59 the day before.
export const parseDateValue = (value: string, timezone: string) =>
  DateTime.fromISO(value, { zone: timezone, setZone: true }).setZone(timezone, {
    keepLocalTime: true,
  });

const DatePickerField = (props: DatePickerFieldProps) => {
  const { name, timezone = 'utc', ...rest } = props;
  const {
    field: { value, ...fieldRest },
    fieldState: { error },
  } = useController({ name });

  return (
    <DatePickerBase
      data-testid="DatePickerField"
      error={error}
      value={value ? parseDateValue(value, timezone) : null}
      timezone={timezone}
      {...fieldRest}
      {...rest}
    />
  );
};

export default DatePickerField;
